import React, { useContext, useEffect } from 'react';
import { usePaginatedQuery } from 'react-query';
import { SimpleGrid, Box } from '@chakra-ui/react';
import Spinner, { SpinnerContainer } from '@interness/web-core/src/components/modules/Spinner/Spinner';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import GridItem from '../GridItem/GridItem';
import { StoreContext } from '../../context/Store';
import { EApiContext } from '../../context/EApi';
import Error from '../Error/Error';
import { jsx as ___EmotionJSX } from "@emotion/react";
const ProductGrid = _ref => {
  let {
    tag
  } = _ref;
  const {
    categoryFilter,
    manufacturersFilter,
    subcategoriesFilter,
    sort,
    setMeta,
    page
  } = useContext(StoreContext);
  const {
    fetchProducts
  } = useContext(EApiContext);
  const {
    isIdle,
    isLoading,
    isError,
    resolvedData,
    latestData
  } = usePaginatedQuery(['products', {
    categoryFilter,
    manufacturersFilter,
    subcategoriesFilter,
    sort,
    tagFilter: tag
  }, page], fetchProducts, {
    refetchOnWindowFocus: false,
    cacheTime: 'Infinity',
    staleTime: 'Infinity',
    enabled: sort.length !== 0
  });
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (resolvedData) {
        setMeta(resolvedData.meta);
      }
    }
    return () => {
      mounted = false;
    };
    //eslint-disable-next-line
  }, [resolvedData]);
  if (isError) {
    return ___EmotionJSX(Error, null, "Fehler beim Laden der Produkte.");
  }
  if (isIdle || isLoading || !latestData) {
    return ___EmotionJSX("div", null, ___EmotionJSX(Spacer, null), ___EmotionJSX(SpinnerContainer, null, ___EmotionJSX(Spinner, null)));
  }
  if (resolvedData.data.length === 0) {
    return ___EmotionJSX("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '50px'
      }
    }, "Keine Produkte gefunden");
  }
  if (resolvedData) {
    return ___EmotionJSX(Box, null, ___EmotionJSX(Wrapper, null, ___EmotionJSX(Spacer, null), ___EmotionJSX(SimpleGrid, {
      minChildWidth: "250px",
      spacing: 5,
      id: 'int-grid'
    }, resolvedData.data.map(product => ___EmotionJSX(GridItem, {
      key: product.id,
      product: product
    })))));
  }
};
export default ProductGrid;